import { Image } from 'antd';

interface KycImageThumbProps {
  src?: string | null;
  alt: string;
  size?: number;
}

// Miniature cliquable (zoom plein écran au clic, géré par antd Image) pour
// toute image KYC affichée dans un tableau — Photo/Signature de signataires/
// procurations, PHOTO/SIGNATURE du client — un seul endroit à changer si le
// rendu doit évoluer. "—" si aucune valeur.
//
// Un seuil de longueur (pas juste !src) : certaines fiches de test ont une
// data URI tronquée/incomplète (ex. juste "data:", sans contenu) — essayer de
// charger ça affiche l'icône "image cassée" native du navigateur à la place
// du "—" attendu. Une vraie data URI d'image fait toujours largement plus de
// 50 caractères (le préfixe seul en fait ~20+), donc ce seuil filtre les
// valeurs manifestement invalides sans jamais rejeter une vraie image.
export const LONGUEUR_MIN_DATA_URI = 50;

export default function KycImageThumb({ src, alt, size = 40 }: KycImageThumbProps) {
  if (!src || src.length < LONGUEUR_MIN_DATA_URI) return <>—</>;
  return (
    <Image
      src={src}
      alt={alt}
      width={size}
      height={size}
      style={{ objectFit: 'cover', borderRadius: 4 }}
    />
  );
}
